// src/InernalSessionBanner.tsx
import { jsx, jsxs } from "react/jsx-runtime";
function InternalSessionBanner(props) {
  if (!props.isInternal) {
    return null;
  }
  return /* @__PURE__ */ jsxs(
    "div",
    {
      id: "internalSessionBanner",
      style: {
        position: "fixed",
        bottom: "1rem",
        left: "1rem",
        zIndex: 999999,
        background: "#FEF3C7",
        border: "2px solid #FCD34D",
        borderRadius: "0.5rem",
        padding: "0.5rem",
        display: "flex",
        flexDirection: "column",
        gap: "0.25rem"
      },
      children: [
        /* @__PURE__ */ jsx(
          "p",
          {
            style: {
              fontWeight: "bold"
            },
            children: "Interne Session"
          }
        ),
        /* @__PURE__ */ jsxs(
          "ul",
          {
            style: {
              listStyle: "none",
              margin: 0,
              padding: 0,
              display: "flex",
              flexDirection: "row",
              gap: "1rem"
            },
            children: [
              /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(
                "a",
                {
                  href: "/stopinternalsession",
                  style: {
                    textDecoration: "underline",
                    color: "#3182CE",
                    cursor: "pointer"
                  },
                  children: "End Session"
                }
              ) }),
              /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(
                "a",
                {
                  href: "?disablecache=true",
                  style: {
                    textDecoration: "underline",
                    color: "#3182CE",
                    cursor: "pointer"
                  },
                  children: "Disable Cache"
                }
              ) })
            ]
          }
        )
      ]
    }
  );
}

// src/AnalyticsBody.tsx
import { Fragment, jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
function AnalyticsBody(props) {
  if (props.isInternal) {
    return /* @__PURE__ */ jsx2(InternalSessionBanner, { isInternal: props.isInternal });
  }
  const tagAttributes = Object.fromEntries(
    Object.entries(props.attributionTags || {}).map(
      ([
        key,
        value
      ]) => [
        `data-tag-${key}`,
        value
      ]
    )
  );
  return /* @__PURE__ */ jsxs2(Fragment, { children: [
    props.googleTagManager ? /* @__PURE__ */ jsx2("noscript", { children: /* @__PURE__ */ jsx2(
      "iframe",
      {
        src: `https://www.googletagmanager.com/ns.html?id=${props.googleTagManager}`,
        title: "GTM",
        height: "0",
        width: "0",
        style: {
          display: "none",
          visibility: "hidden"
        }
      }
    ) }) : null,
    props.pirschCode ? /* @__PURE__ */ jsx2(
      "script",
      {
        id: "pianjs",
        src: "https://api.pirsch.io/pa.js",
        "data-code": props.pirschCode,
        ...tagAttributes,
        defer: true
      }
    ) : null
  ] });
}

// src/AnalyticsHead.tsx
import { useEffect } from "react";
import { Fragment as Fragment2, jsx as jsx3 } from "react/jsx-runtime";
function AnalyticsHead(props) {
  useEffect(() => {
    window.__loadGtm?.();
    window.__loadGtm = void 0;
  }, []);
  if (props.isInternal) {
    return null;
  }
  return /* @__PURE__ */ jsx3(Fragment2, { children: Object.entries(scripts).map(
    ([
      name,
      scriptBuilder
    ]) => {
      const scriptHtml = scriptBuilder(props);
      if (!scriptHtml) {
        return null;
      }
      if (scriptHtml.startsWith("http://")) {
        console.warn("Script is not https", scriptHtml);
        return null;
      }
      if (scriptHtml.startsWith("https://") || scriptHtml.startsWith("//") || scriptHtml.startsWith("/")) {
        return /* @__PURE__ */ jsx3(
          "script",
          {
            src: scriptHtml
          },
          name
        );
      }
      return /* @__PURE__ */ jsx3(
        "script",
        {
          dangerouslySetInnerHTML: {
            __html: scriptHtml
          }
        },
        name
      );
    }
  ) });
}
var scripts = {
  // It seems that this is the same as gtag
  // gtm: (props: Props) => {
  //   const id = props.googleTagManager;
  //
  //   if (!id) return '';
  //
  //   return `https://www.googletagmanager.com/gtag/js?id=${id}`;
  // },
  gtminline: (props) => {
    const id = props.googleAnalytics;
    if (!id) {
      return "";
    }
    return `window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', '${id}');`;
  },
  gtag: (props) => {
    const querystring = props.googleTagManager;
    if (!querystring) {
      return "";
    }
    return `window.__loadGtm=function(){(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.defer=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${querystring}');};`;
  }
};

// src/InternalSessionCookie.ts
var InternalSessionCookie = class {
  cookie;
  constructor(createCookie) {
    this.cookie = createCookie("internal", {
      maxAge: 60 * 60 * 24 * 365
      // Seconds
    });
  }
  async isInternal(request) {
    const cookieHeader = request.headers.get("Cookie");
    const cookie = await this.cookie.parse(cookieHeader);
    return Boolean(cookie);
  }
  async serialize(isInternal) {
    return await this.cookie.serialize(isInternal);
  }
};

// src/handleMarketingParams.ts
var LS_KEY_MARKETING_PARAMS = "marketingParams";
var PARAMS_VERSION = 1713791463090;
var TIMESTAMP_LEGACY = "2024-01-31T23:00:00.000Z";
function handleMarketingParams(params) {
  try {
    if (!localStorage || !sessionStorage) {
      return [];
    }
    let marketingParams = loadMarketingParams();
    if (marketingParams.version !== PARAMS_VERSION) {
      marketingParams = migrateMarketingParams(marketingParams);
    }
    if (!params) {
      return marketingParams.history || [];
    }
    const newEntry = {};
    for (const [
      key,
      value
    ] of params) {
      const fixedKey = key.toLowerCase();
      if (!fixedKey.startsWith("utm_")) {
        continue;
      }
      newEntry[fixedKey] = value;
    }
    if (!newEntry.utm_source || !newEntry.utm_medium || !newEntry.utm_campaign) {
      return marketingParams.history || [];
    }
    newEntry.timestamp = (/* @__PURE__ */ new Date()).toISOString();
    let newestEntry = marketingParams.history?.[0] || {};
    if (newestEntry.utm_source === newEntry.utm_source && newestEntry.utm_medium === newEntry.utm_medium && newestEntry.utm_campaign === newEntry.utm_campaign) {
      marketingParams.history[0] = newEntry;
    } else {
      marketingParams.history?.unshift(newEntry);
    }
    newestEntry = newEntry;
    marketingParams.history?.sort(
      (a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
    );
    localStorage.setItem(
      LS_KEY_MARKETING_PARAMS,
      JSON.stringify(marketingParams)
    );
    const gaKeys = [
      "utm_campaign",
      "utm_content",
      "utm_medium",
      "utm_source"
    ];
    for (const key of gaKeys) {
      localStorage.setItem(`ga_${key}`, newestEntry[key] || "");
    }
    localStorage.setItem("ga_utm_timestamp", String(Date.now()));
    return marketingParams.history || [];
  } catch (e) {
    console.error("handleMarketingParams", e);
    return [];
  }
}
function loadMarketingParams() {
  try {
    const value = localStorage.getItem(LS_KEY_MARKETING_PARAMS);
    if (!value) {
      return {};
    }
    const parsedValue = JSON.parse(value);
    if (typeof parsedValue !== "object") {
      return {};
    }
    return parsedValue || {};
  } catch (e) {
    console.error("loadMarketingParams", e);
    return {};
  }
}
function migrateMarketingParams(marketingParams) {
  try {
    if (marketingParams.version === PARAMS_VERSION) {
      return marketingParams;
    }
    const history = [];
    if (!marketingParams.version) {
      const legacyHistory = loadLegacyHistory();
      for (const entry of legacyHistory) {
        const newEntry = {};
        for (const [
          key,
          value
        ] of Object.entries(entry)) {
          newEntry[key] = String(value);
        }
        history.push(newEntry);
      }
    }
    history.sort(
      (a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
    );
    const newMarketingParams = {
      version: PARAMS_VERSION,
      history
    };
    localStorage.setItem(
      LS_KEY_MARKETING_PARAMS,
      JSON.stringify(newMarketingParams)
    );
    localStorage.removeItem("utmParamsList");
    localStorage.removeItem("utmParams");
    return newMarketingParams;
  } catch (e) {
    console.error("migrateMarketingParams", e);
    return marketingParams;
  }
}
function loadLegacyHistory() {
  try {
    let utmParamsList = null;
    const rawUtmParamsList = localStorage.getItem("utmParamsList");
    if (rawUtmParamsList) {
      utmParamsList = JSON.parse(rawUtmParamsList);
    }
    if (!utmParamsList) {
      const rawUtmParams = localStorage.getItem("utmParams");
      if (rawUtmParams) {
        utmParamsList = [JSON.parse(rawUtmParams)];
      }
    }
    if (!utmParamsList) {
      const rawGaUtmParams = {
        utm_source: localStorage.getItem("ga_utm_source") || "",
        utm_medium: localStorage.getItem("ga_utm_medium") || "",
        utm_campaign: localStorage.getItem("ga_utm_campaign") || ""
      };
      if (rawGaUtmParams.utm_source && rawGaUtmParams.utm_medium && rawGaUtmParams.utm_campaign) {
        utmParamsList = [rawGaUtmParams];
      }
    }
    if (!utmParamsList || typeof utmParamsList !== "object") {
      return [];
    }
    if (!Array.isArray(utmParamsList)) {
      utmParamsList = [
        utmParamsList
      ];
    }
    const fixedList = [];
    for (const utmParamsListElement of utmParamsList) {
      if (typeof utmParamsListElement !== "object" || !utmParamsListElement) {
        continue;
      }
      if (!utmParamsListElement.utm_source || !utmParamsListElement.utm_medium || !utmParamsListElement.utm_campaign) {
        continue;
      }
      if (!utmParamsListElement.timestamp) {
        utmParamsListElement.timestamp = TIMESTAMP_LEGACY;
      }
      fixedList.push(utmParamsListElement);
    }
    return fixedList;
  } catch (e) {
    console.error("loadLegacyHistory", e);
    return [];
  }
}

// src/trackLinkClicks.ts
import { useEffect as useEffect2 } from "react";

// src/channel.ts
var CHANNEL_VALUES = [
  "valiant",
  "direct",
  "other"
];
var ATTRIBUTION_STORAGE_KEY = "as_attribution";
var TAG_VALUE_MAX_LENGTH = 50;
var UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term"
];
var VALIANT_COMPANY_ID = "dca7b5";
function resolveChannel(input) {
  const url = safeParseUrl(input.url);
  const referrerUrl = input.referrer ? safeParseUrl(input.referrer) : null;
  const channelParam = url?.searchParams.get("channel")?.trim().toLowerCase();
  if (channelParam && isChannel(channelParam)) {
    return channelParam;
  }
  const utmSource = url?.searchParams.get("utm_source")?.trim().toLowerCase();
  if (utmSource) {
    return utmSource.includes("valiant") ? "valiant" : "other";
  }
  const pathname = url?.pathname || "";
  if (pathname.includes("/valiant") || input.companyId === VALIANT_COMPANY_ID) {
    return "valiant";
  }
  const referrerHost = referrerUrl?.hostname.toLowerCase() || "";
  if (referrerHost.includes("valiant")) {
    return "valiant";
  }
  if (referrerUrl && url && referrerUrl.hostname !== url.hostname) {
    return "other";
  }
  if (input.stored?.channel) {
    return input.stored.channel;
  }
  return "direct";
}
function isChannel(value) {
  return CHANNEL_VALUES.includes(value);
}
function safeParseUrl(value) {
  try {
    return new URL(value, "https://placeholder.invalid");
  } catch {
    return null;
  }
}
function truncate(value) {
  return value.slice(0, TAG_VALUE_MAX_LENGTH);
}
function readUtmParamsFromUrl(url) {
  const parsed = safeParseUrl(url);
  if (!parsed) return {};
  const result = {};
  for (const key of UTM_KEYS) {
    const value = parsed.searchParams.get(key)?.trim();
    if (value) {
      result[key] = truncate(value);
    }
  }
  return result;
}
function computeAttributionTags(input) {
  const channel = resolveChannel(input);
  const utm = readUtmParamsFromUrl(input.url);
  const tags = { channel };
  for (const [
    key,
    value
  ] of Object.entries(utm)) {
    if (value) tags[key] = value;
  }
  return tags;
}
function persistAttribution(input) {
  const existing = readAttribution();
  if (existing) {
    return existing;
  }
  const channel = resolveChannel({ ...input, stored: existing });
  const utm = readUtmParamsFromUrl(input.url);
  const attribution = {
    channel,
    ...utm
  };
  try {
    if (typeof sessionStorage !== "undefined") {
      sessionStorage.setItem(
        ATTRIBUTION_STORAGE_KEY,
        JSON.stringify(attribution)
      );
    }
  } catch (e) {
    console.error("persistAttribution", e);
  }
  return attribution;
}
function readAttribution() {
  try {
    if (typeof sessionStorage === "undefined") {
      return null;
    }
    const raw = sessionStorage.getItem(ATTRIBUTION_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object" || !isChannel(parsed.channel)) {
      return null;
    }
    return parsed;
  } catch (e) {
    console.error("readAttribution", e);
    return null;
  }
}
function attributionMeta() {
  const attribution = readAttribution();
  if (!attribution) return {};
  const meta = {
    channel: attribution.channel
  };
  for (const key of UTM_KEYS) {
    const value = attribution[key];
    if (value) {
      meta[key] = truncate(value);
    }
  }
  return meta;
}

// src/trackLinkClicks.ts
var TRACK_ATTRIBUTE = "data-track";
var DOCUMENT_MARKER = "__agentSellyLinkClickTrackingInstalled";
function handleClick(event) {
  const target = event.target;
  if (!(target instanceof Element)) return;
  const trackedElement = target.closest(`[${TRACK_ATTRIBUTE}]`);
  if (!trackedElement) return;
  const eventName = trackedElement.getAttribute(TRACK_ATTRIBUTE);
  if (!eventName) return;
  const pirsch = window.pirsch;
  const meta = attributionMeta();
  pirsch?.(eventName, Object.keys(meta).length ? { meta } : void 0)?.catch(
    () => {
    }
  );
}
function installLinkClickTracking() {
  const doc = document;
  if (doc[DOCUMENT_MARKER]) {
    return () => {
    };
  }
  doc[DOCUMENT_MARKER] = true;
  document.addEventListener("click", handleClick, { capture: true });
  return () => {
    document.removeEventListener("click", handleClick, { capture: true });
    doc[DOCUMENT_MARKER] = false;
  };
}
function useLinkClickTracking() {
  useEffect2(() => installLinkClickTracking(), []);
}
function trackEvent(name, extraMeta) {
  const pirsch = window.pirsch;
  const meta = { ...attributionMeta() };
  if (extraMeta) {
    for (const [
      key,
      value
    ] of Object.entries(extraMeta)) {
      meta[key] = String(value);
    }
  }
  pirsch?.(name, Object.keys(meta).length ? { meta } : void 0)?.catch(
    () => {
    }
  );
}
export {
  ATTRIBUTION_STORAGE_KEY,
  AnalyticsBody,
  AnalyticsHead,
  InternalSessionBanner,
  InternalSessionCookie,
  attributionMeta,
  computeAttributionTags,
  handleMarketingParams,
  installLinkClickTracking,
  persistAttribution,
  readAttribution,
  resolveChannel,
  trackEvent,
  useLinkClickTracking
};
